import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import OnePublication from "./OnePublication";
import Filter from "./Filter";
import { getInlineLoader } from "../Helpers";
import { Link } from "react-router-dom";

export default function PublicationContent({
  compact = false,
  showHeader = true,
}) {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);
  const [filter, setFilter] = useState("");

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllPublications()]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    const publications = appContext.allPublications || [];
    const filteredPublications = publications.filter((item) =>
      item.title.toLowerCase().includes(filter.toLowerCase()),
    );

    return (
      <div
        className="MainBodySection bg-background publication-content-shell"
        style={
          compact
            ? { paddingTop: "10px", paddingBottom: "0px" }
            : { paddingTop: "50px", paddingBottom: "50px" }
        }
      >
        <div className={compact ? "container-fluid px-0" : "container"}>
          <div className="row">
            {showHeader && !compact ? (
              <div className="col-md-12 text-center">
                <h4 className="main-section-title">
                  Publications
                  <span
                    style={{
                      display: "block",
                      borderBottom: "3px solid var(--secondaryColor)",
                      width: "50px",
                      margin: "10px auto 0",
                    }}
                  ></span>
                </h4>
              </div>
            ) : null}

            {!compact && <Filter filter={filter} setFilter={setFilter} />}

            {filter && filter.trim().length > 0 && !compact && (
              <div className="col-md-12 text-center mb-4">
                <h6 className="font-light" style={{ fontSize: "18px" }}>
                  Search Results For:{" "}
                  <span className="font-semi-bold">{filter}</span>
                </h6>
              </div>
            )}

            <div className="col-md-12">
              <div className="row">
                {filteredPublications.length > 0 ? (
                  (compact
                    ? filteredPublications.slice(0, 2)
                    : filteredPublications
                  ).map((item) => (
                    <div
                      className="col-lg-6 mb-4"
                      key={item.uuid}
                      data-aos="fade-up"
                    >
                      <OnePublication data={item} />
                    </div>
                  ))
                ) : (
                  <div className="col-md-12 mb-1 mt-1">
                    <h6>
                      {filter
                        ? "No matching publications found"
                        : "No data was found"}
                    </h6>
                  </div>
                )}
              </div>
            </div>

            {compact ? (
              <div className="text-center mt-2">
                <Link
                  to="/publications"
                  className="btn btn-outline-primary btn-rounded btn-padded"
                >
                  View All Publications
                </Link>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
